<template>
  <div id="users">
    <notifications group="notify" position="top center"  />
    <div class="users-menu">
          <div class="container">
            <div class="image text-center" style="margin-top:20px; padding-bottom: 20px;">
                <a href="/#/motorista/promocoes">
                  <img src="/images/logo.png" id="logo-soganhei-app" alt="Logo SóGanhei"> 
                </a>
            </div>
            <div>
              <p>Bem-vindo, {{ users.name }}</p> 
              <a href="/#/motorista/promocoes">Voltar</a>
              <a href="javascript:void(0)" @click="login()" title="Sair" class="float-right"><i class="fa fa-sign-out-alt"></i></a>
            </div>
            
          </div>       
    </div>

    <Indicacao  ref="Indicacao" v-on:indicacoes="indicacoes"  />
    
    <div class="container" style="margin-top:20px">
        
          <h1>Indicações</h1><br>
           <button class="btn btn-outline-primary" @click="visualizarIndicacao()">Nova indicação</button>
           <br><br>
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>                                   
                  <th>Responsável</th>
                  <th>Status</th> 
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.id">
                 
                  <td>{{item.nomeParceiro}}</td>                   
                  <td>{{item.statusNegociacao}}</td>                 
                
                </tr>
              </tbody>
            </table>
          </div>

          
    </div>      
  </div>
</template>
<style>
  
 
</style>
<script>
 
 
import {AdminService} from "@/http"

import moment from 'moment'

import {statusIndicacao} from "@/soganhei"

 
export default {
  name: "Cupons",
  components: {
       
  },
  data: () => {
    return {
      items:[],       
    };
  },
  methods: {   
     
     indicacoes(){

       AdminService.Indicacoes().then(response=>{

         this.items = response.data.map(item=>{
              
            item.timezoneAdmin = moment(item.timezoneAdmin).utc().locale("pt-br").format("LLL")
            item.statusNegociacao = statusIndicacao(item.statusNegociacao)
              return item
          })

      }).catch(error=>{
            window.console.error(error.response)
      })

     }
  },
  created(){

      
      this.indicacoes()
     

  }
};
</script>

 


 
